import utils from '../../../common/utils'

class authenticationModalCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, $rootScope) {
        $scope.authorizeId = items1.authorizeId
        httpRequest.post_findByAuthorizeId($scope.authorizeId).then((res) => {
            $scope.formObj = res.data
            if (items1.mobile) {
                $scope.formObj.copyMobile = items1.mobile
            }
        })

        let countDown = 120
        $scope.timing = countDown + 's'
        $scope.verifCode = ''
        $scope.submitBtnDisabled = true

        function settime() {
            if (countDown > 0) {
                setTimeout(function () {
                    settime(countDown--)
                    $scope.$apply()
                }, 1000)
                $scope.timing = countDown + 's'
            } else {
                $scope.timing = '重新发送'
                $scope.submitBtnDisabled = false
                document.getElementById('submitBtn').className = 'btnStyle'
            }
        }
        settime()
        $scope.reacQuire = function () {
            let data = {
                authorizeId: $scope.authorizeId,
                force: false,
            }
            httpRequest.post_getToken(data).then((res) => {
                //loginStatus 1登录成功  0未登录
                // smsStatus
            })

            if (countDown <= 0) {
                countDown = 120
                $scope.timing = countDown + 's'
                settime()
                $scope.submitBtnDisabled = false
                document.getElementById('submitBtn').className = 'btnStyle1'
            }
        }

        $scope.ok = function () {
            if (!$scope.verifCode) return logger.logError('请填写您收到的短信验证码后提交！')
            let data = {
                authorizeId: $scope.authorizeId,
                smsCode: $scope.verifCode,
            }
            utils.loading('请求已发送...')
            httpRequest.post_smsValid(data).then((res) => {
                utils.loaded()
                logger.logSuccess('登录成功')
                $uibModalInstance.close('ok')
                $rootScope.$broadcast('sms_logIn', true)
                $rootScope.$emit('certificationStatusChange')
            })
        }
        $scope.cancel = function () {
            $uibModalInstance.dismiss()
        }
    }
}

authenticationModalCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', '$rootScope']
export default authenticationModalCtrl



// WEBPACK FOOTER //
// ./src/app/main/common/authenticationModalCtrl.js